import { Cause } from '@/models/Cart/Discount'

class DeliveryCharge {
  constructor({ id, cause, standardAmount, discountDeliveryCharge, deliveryCharge, deliveryChargeBeforeDiscount = 0 }) {
    this.id = id
    this.standardAmount = standardAmount
    this.discountDeliveryCharge = discountDeliveryCharge
    this.cause = new Cause(cause)
    this.deliveryCharge = deliveryCharge
    this.deliveryChargeBeforeDiscount = deliveryChargeBeforeDiscount
  }

  getId() {
    return this.id
  }

  getCause() {
    return this.cause
  }

  getDeliveryCharge() {
    return this.deliveryCharge
  }

  getDeliveryChargeBeforeDiscount() {
    return this.deliveryChargeBeforeDiscount
  }
}

export default DeliveryCharge
